module.exports = __webpack_public_path__ + "img/nightingale_title--success.cca13d3a.png";